import React from "react";

export default function PrivacyPolicy() {
  return (
    <div className="container">
      <h1>Privacy Policy</h1>

      <h2>Your info, in focus.</h2>
      <h3>Getting to know our privacy policy.</h3>
      <p>
        Some things are meant to be shared. Like that time-lapse photo
        you&rsquo;re really proud of. Or the holiday album you&rsquo;ve just put
        together. But your personal details? Not so much. At Canon, we respect
        your privacy. And we also respect your right to know how we handle your
        personal information. So to make things clearer, here are the ins and
        outs of our Privacy Policy.
      </p>
      <h2>WHAT</h2>
      <h3>is personal information?</h3>
      <p>
        Personal information is just that &ndash; personal. It&rsquo;s all the
        little details about yourself that tell us who you are &ndash; like
        where you&rsquo;re from, and what sort of business you&rsquo;re doing
        with Canon.
      </p>
      <p>
        We only collect what&rsquo;s reasonably necessary to assist you and run
        our business. Mainly we collect names, contact details, purchase
        records, payment details, info about use of our services,
        correspondence, and other info you might choose to share with us, like
        your interests.
      </p>
      <h2>WHY</h2>
      <h3>do you need my details?</h3>
      <p>
        We collect your personal info to better provide you with products and
        services and because it helps us to know more about you. And when we
        know more about you, we can provide you with the best possible service.
      </p>
      <p>
        So whether it&rsquo;s learning which of our products you&rsquo;re liking
        &ndash; and not liking so much &ndash; or where we can improve our
        service, you&rsquo;re always helping us to be a better business.
      </p>
      <h2>HOW</h2>
      <h3>do you collect my info?</h3>
      <p>There are various instances where we collect your details, such as:</p>
      <ul>
        <li>
          When you purchase products directly from us &ndash; including the
          online store and our PhotoPICO website&nbsp;
        </li>
        <li>
          When you subscribe to our online services, such as Canon Image Gateway
          and our image management service&nbsp;
        </li>
        <li>
          When you register as a member of MyCanon and use your MyCanon account
          (including wishlists, product registrations and reviews)&nbsp;
        </li>
        <li>
          When you sign in with a social account to use MyCanon account
          features&nbsp;
        </li>
        <li>
          When you subscribe to our consumer or business e-newsletters and
          respond to links in those communications&nbsp;
        </li>
        <li>
          When you participate in a competition, promotion, event, or any other
          activity we&rsquo;ve got going on&nbsp;
        </li>
        <li>When you make a warranty claim on a product&nbsp;</li>
        <li>
          When you apply for a job with us. If you do this, we might also
          collect other relevant information from third party sources, like
          referees&nbsp;
        </li>
        <li>
          When you get in touch with any inquiries, comments or complaints&nbsp;
        </li>
        <li>
          When you browse our website. We do this by using cookies to track your
          activity on the site &ndash; unless you turn this off on your
          browser&nbsp;
        </li>
        <li>
          When you transact or communicate with us on behalf of a
          business.&nbsp;
        </li>
        <li>
          If you&rsquo;re a potential business contact or customer, we might
          collect information from indirect sources like list purchases or
          records available to the public.
        </li>
      </ul>
      <h2>HOW</h2>
      <h3>do you use my info?</h3>
      <p>There&rsquo;s a few ways we use your personal info. It helps us to:</p>
      <ul>
        <li>Supply products and services&nbsp;</li>
        <li>Provide information and training&nbsp;</li>
        <li>Provide commercial credit and finance to individuals&nbsp;</li>
        <li>Manage our commercial relationships&nbsp;</li>
        <li>
          Promote our brand &ndash; and figure out the best ways to market
          it&nbsp;
        </li>
        <li>
          Improve our products and services, as well as how we communicate with
          the public&nbsp;
        </li>
        <li>
          Tailor our products, services and marketing to your individual
          needs&nbsp;
        </li>
        <li>Manage our business as best as possible&nbsp;</li>
        <li>Obey the law (that one&rsquo;s especially important).</li>
      </ul>
      <h3>Let&rsquo;s be direct about direct marketing.</h3>
      <p>
        We&rsquo;ll only use your personal info for direct marketing purposes
        when we&rsquo;re permitted to under the Privacy Act 1988 &ndash; the
        same way we&rsquo;ll only send you emails for commercial reasons when
        it&rsquo;s in accordance with the Spam Act 2003.
      </p>
      <p>
        And if you&rsquo;re not interested, you can opt out at any time by
        unsubscribing from emails or contacting our Privacy Officer.
      </p>
      <h3>Keeping it under lock and key.</h3>
      <p>
        We know how important it is to keep your details secure. And
        that&rsquo;s why we have a whole range of processes in place to protect
        that information, including:
      </p>
      <ul>
        <li>
          Using secure servers and other appropriate measures to protect
          electronic data&nbsp;
        </li>
        <li>
          Making sure only the necessary Canon employees have access to your
          info &ndash; using internal access policies, physical access
          restrictions, network structures, passwords, access tracking and
          more&nbsp;
        </li>
        <li>
          Ensuring any credit card payments to the Canon Store and PhotoPICO are
          made through a secure gateway service.
        </li>
      </ul>
      <p>
        And when your details aren&rsquo;t needed anymore, we&rsquo;ll always
        make sure they&rsquo;re destroyed, deleted or de-identified.
      </p>
      <h2>WHO</h2>
      <h3>do you share my info with?</h3>
      <p>
        We may need to share your details with some of our providers &ndash;
        like companies that provide us with IT and delivery services.
      </p>
      <p>
        Some of these companies are likely to be based overseas. For instance,
        we use cloud computing services hosted in Europe and the Asia Pacific to
        store some of our data &ndash; and call centre and business process
        services based in New Zealand, India and the Phillipines.
      </p>
      <p>
        But don&rsquo;t worry. Because we&rsquo;ll only ever disclose what is
        necessary for them to do their job &ndash; and all of these parties are
        contractually obliged to keep your details safe.
      </p>
      <h3>Going public.</h3>
      <p>
        We&rsquo;ll only share your personal details, or any images provided by
        you, publicly if that&rsquo;s what you intended or agreed to. This could
        be:
      </p>
      <ul>
        <li>
          User contributions to the Canon website, like product reviews
          (although you&rsquo;ll also have the option to use a display
          name)&nbsp;
        </li>
        <li>
          If you win a competition (and our terms and conditions have permitted
          us to do so)&nbsp;
        </li>
        <li>
          If you&rsquo;ve given us permission to share your info with an
          integrated third party service, like a social media platform.
        </li>
      </ul>
      <h2>WHERE</h2>
      <h3>can I get in touch about my info?</h3>
      <p>
        You have rights to access info we hold about you &ndash; and to ask us
        to correct these details if they&rsquo;re wrong. All you need to do is
        get in touch with our Privacy Officer.
      </p>
      <p>
        You can also get in touch with them if you have any complaints about how
        we&rsquo;ve handled your information. They&rsquo;ll investigate for you
        &ndash; and respond in writing as quickly as possible. If you&rsquo;re
        still not satisfied with the Privacy Officer&rsquo;s response,
        it&rsquo;s your right under the Privacy Act to lodge a complaint with
        the Office of the Australian Information Commissioner (OAIC).
      </p>
      <h3>Here&rsquo;s how you can reach our Privacy Officer:</h3>
      <p>
        Privacy Officer
        <br /> Canon Australia Pty Ltd
        <br /> 1 Thomas Holt Drive
        <br /> NORTH RYDE NSW 2113
        <br /> (02) 9805 2077
        <br /> privacyofficer@canon.com.au&gt;
      </p>
      <p>
        This Policy covers Canon Australia Pty Ltd and its Australian
        subsidiaries, including Canon Finance Australia Pty Ltd and <br />
        Oce-Australia Pty Ltd.
      </p>
    </div>
  );
}
